export default __webpack_public_path__ + "c49d02842f6e894fcbb811248e60da8f.png";